import { CancelTokenSource } from "axios";
import { useEffect } from "react";

const cancelSources = (sources: CancelTokenSource[]) =>
  sources.forEach(source => source.cancel());

const useCancelRequests = (sources: CancelTokenSource[]) => {
  window.onbeforeunload = () => cancelSources(sources);
  useEffect(() => {
    return () => {
      cancelSources(sources);
    };
  }, []);
};

export default useCancelRequests;
